import { FormattedMessage } from 'react-intl';

const NoRowsOverlay = () => {
  return (
    <div className="d-flex flex-column align-items-center gap-2 text-secondary">
      <i className="icon icon-xl icon-outlined">table_chart</i>
      <h4 className="">
        <FormattedMessage id="secondary-market-batch-grid.no-rows.title" />
      </h4>
      <FormattedMessage id="secondary-market-batch-grid.no-rows.subtitle" />
    </div>
  );
};

export default NoRowsOverlay;
